import styled from 'styled-components';

const DashboardStyles = styled.section`
    .please-connect {
        padding: 40px;

        color: #FFF;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.2;
        text-align: center;
    }
`

export default DashboardStyles;